import { createAction, createReducer } from "@reduxjs/toolkit"

// ACTIONS
export const addRecentSearch = createAction("location/addRecentSearch")
export const removeRecentSearch = createAction("location/removeRecentSearch")

// INITIAL STATE
const initialState = {
  recentSearches: []
}

// REDUCER
const locationReducer = createReducer(initialState, {
  [addRecentSearch.type]: (state, action) => {
    // Add new search to top, remove duplicates, keep max 5
    state.recentSearches = [
      action.payload,
      ...state.recentSearches.filter(item => item.place_id !== action.payload.place_id)
    ].slice(0, 5)
  },
  [removeRecentSearch.type]: (state, action) => {
    state.recentSearches = state.recentSearches.filter(item => item.place_id !== action.payload)
  }
})

export default locationReducer